<template lang="pug">
  .map-themes
    .themes
      div(style="padding: 0 1em; margin-top: 1em;")
        h4.heading
          span Select a map theme:
          span.view-legend(@click="toggleLegend") VIEW LEGEND
        v-list(dense)
          v-list-group(v-if="mapThemes" v-for="category in mapThemes" :key="category.name" :value="category.name === 'Wildfire Risk Themes'")
            v-list-tile(slot="activator") {{category.name}}
            v-list-tile(v-for="layer in category.layers" :key="layer.name")
              v-list-tile-content(style="height: auto !important")
                v-switch(
                  :label="layer.name"
                  :value="getVisible(layer)"
                  @change="onLayerVisibilityChange(layer)"
                  color="primary"
                  :input-value="getVisible(layer)"
                  :ripple="false"
                )
    .controls
      .spacer
      v-alert.elevation-3.section-alert.transparency-alert(color="grey lighten-3" :value="true")
        h4 Adjust Theme Transparency:
        v-slider(v-model="transparency" step="1" max="100" min="0" thumb-label @input="onOpacityChange")
      v-alert.elevation-3.section-alert(color="secondary" :value="true" v-if="selectedLayer")
        h4 Active Map theme:
        h5 {{ selectedLayer.name }}
        p {{ description }}
      v-alert.elevation-3.section-alert(color="secondary" :value="true" v-else)
        h4 Active Map theme:
        p Please select a map theme.
      v-btn(
        block
        color="secondary"
        class="black--text"
        href="https://help.coloradoforestatlas.org/public/map-theme-descriptions"
        target="_blank"
      )
        v-icon(left) info
        | FULL THEME DESCRIPTIONS
</template>

<script>
import {
  setLayerVisibility,
  setOpacity,
  getMap,
  toggleLegend,
  getPseudoIdentifyOverlay,
} from "@/services/map";
import { eventBus } from "@/services/utils";
import store from "../store";
export default {
  data() {
    return {
      transparency: 25,
      mapTheme: 0,
      mapThemes: null,
      selectedLayer: null,
    };
  },
  created() {
    eventBus.$on("map-created", () => {
      this.mapThemes = getMap()
        .getLayers()
        .getArray()
        .filter((l) => l.values_.type === "theme")
        .map((lg) => {
          return {
            name: lg.values_.name,
            layers: lg
              .getLayers()
              .getArray()
              .map((l) => {
                return {
                  name: l.values_.name,
                  visible: l.values_.visible,
                  description: l.values_.description,
                  layerObject: l,
                };
              }),
          };
        });
      for (const theme of this.mapThemes) {
        for (const layer of theme.layers) {
          if (layer.visible) {
            this.selectedLayer = layer;
            store.commit("setselectedmaptheme", layer);
            break;
          }
        }
        if (this.selectedLayer) break;
      }
      // setup map click event for pseudoidentify on map themes
      getMap().on("click", async (event) => {
        if (this.identifyToolActive() || this.fireIntensityActive()) return;
        const layer = this.selectedLayer.layerObject;
        const geoserverLayerId = layer.getSource().getParams().layers;
        const identifyUrl = layer.getSource().getFeatureInfoUrl(
          event.coordinate,
          getMap()
            .getView()
            .getResolution(),
          getMap()
            .getView()
            .getProjection(),
          { INFO_FORMAT: "text/html" }
        );
        const res = await fetch(
          identifyUrl + "&QUERY_LAYERS=" + geoserverLayerId
        );
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        // get the first <td> content
        const td = doc.querySelector("td");
        if (!td) return;
        this.$store.commit(
          "setThemeIdentifyValue",
          td.textContent.replace(/\n/g, "")
        );
        const overlay = getPseudoIdentifyOverlay();
        overlay.setPosition(event.coordinate);
      });
    });
  },
  computed: {
    description() {
      if (!this.selectedLayer) return "";
      return this.selectedLayer.description;
    },
  },
  watch: {
    selectedLayer() {
      getPseudoIdentifyOverlay().setPosition(undefined);
    },
  },
  methods: {
    identifyToolActive() {
      const el = document.getElementById("olIdentifyTool");
      if (!el) return false;
      if (el.innerHTML === "") return false;
      return el.style.display !== "none";
    },
    fireIntensityActive() {
      const el = document.getElementById("fireIntensityDrawFinish");
      if (!el) return false;
      return el.style.display !== "none";
    },
    getVisible(layer) {
      return layer.layerObject.getVisible();
    },
    onLayerVisibilityChange(layer) {
      if (this.selectedLayer === layer) {
        // off switch
        this.selectedLayer = null;
      } else {
        this.selectedLayer = layer;
      }
      const selectedLayerToStore = this.selectedLayer === null ? {} : this.selectedLayer
      store.commit("setselectedmaptheme", selectedLayerToStore);
      this.mapThemes.forEach((c) => {
        c.layers.forEach((l) =>
          setLayerVisibility(
            l.name,
            !this.getVisible(l) && l.name === layer.name,
            c.name
          )
        );
      });
    },
    clearSelection() {
      this.selectedLayer = null;
      store.commit("setselectedmaptheme", {});
      this.mapThemes.forEach((l) => {
        l.visible = false;
        setLayerVisibility(l.name, l.visible);
        this.mapTheme = 0;
      });
    },
    onOpacityChange() {
      setOpacity(
        Math.abs(this.transparency - 100) / 100,
        this.mapThemes
          .map((g) => {
            let lnames = [];
            lnames.push(g.name);
            return lnames;
          })
          .flat()
      );
    },
    toggleLegend,
  },
};
</script>

<style lang="stylus" scoped>
.inset
  padding-left 1em
.map-themes
  display flex
  flex-direction column
  .themes
    .heading
      display flex
      flex-direction row
      justify-content space-between
      align-items  center
      span.view-legend
        cursor pointer
        font-size .8em
        font-weight bold
        color #004f27
  .controls
    padding 1em
    .spacer
      background-color lightgrey
      height .1em
      margin-bottom 1em
    .v-alert
      width 100% !important
      margin-bottom .8em
    .transparency-alert
      padding-bottom 0
    .heading
      width 100%
      display flex
      justify-content space-between
      span
        font-size 13px
      .clear
        color #004F27
        font-size 0.8em
      .legend
        color white
        font-size .8em
    .section-alert
      color #333333
      width 275px
      border 0
      &.dark
        color white
      h4
        margin-bottom .5em
      h5
        text-decoration underline
</style>

<style lang="stylus">
.map-themes
  .v-btn,.v-btn--block
    margin-bottom 1.5em
  .v-list
    .v-list__tile
      padding-left 0
      font-size 12px
    .v-input--selection-controls.v-input--switch
      padding-left 5px
      margin-top 0
    .v-input
      label.v-label
        font-size 12px
        font-weight bold
</style>
